import * as constants from '../constants';

const INITIAL_STATE = {
    items: [],
    page: 1,
    count: 0,
    loading: false,
    error: null,
    invalid: false,
    filterText: '',
    sortBy: '',
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case constants.AUTH_LOGOUT:
        case constants.AUTH_LOGIN_SUCCESS:
            return INITIAL_STATE;

        case constants.SURVEY_LIST_REQUESTED:
            return Object.assign({}, state, {loading: true, error: null});
        case constants.SURVEY_LIST_SUCCESS:
            return Object.assign({}, state, {loading: false, items: action.payload.data.items, count: action.payload.data.count, error: null, invalid: false});
        case constants.SURVEY_LIST_FAILURE:
            return Object.assign({}, state, {loading: false, items: [], count: 0, error: action.payload.error});
        case constants.SURVEY_DELETE_REQUESTED:
        case constants.SURVEY_DELETE_INSTANCES_REQUESTED:
            return Object.assign({}, state, {loading: true, error: null});
        case constants.SURVEY_DELETE_SUCCESS:
        case constants.SURVEY_DELETE_INSTANCES_SUCCESS:
            return Object.assign({}, state, {loading: false, error: null, invalid: true});
        case constants.SURVEY_DELETE_FAILURE:
        case constants.SURVEY_DELETE_INSTANCES_FAILURE:
            return Object.assign({}, state, {loading: false, error: action.payload.error});
        case constants.SURVEY_LIST_CHANGE_PAGE:
            return Object.assign({}, state, {page: action.payload.page});
        case constants.SURVEY_LIST_CHANGE_FILTER:
            return Object.assign({}, state, {filterText: action.payload.filterText, sortBy: action.payload.sortBy});
    }
    return state;
}
